import React from "react";

import { Button, Form, Stack } from "react-bootstrap";

import HeaderRegistration from "../../components/headerRegistration/HeaderRegistration";
import GoBack from "../../components/goBack/GoBack";

import { t } from "i18next";
import { gestioneSnackbar } from "../../../../utils/common";

const StepAssociation1 = ({
  activationCode,
  setActivationCode,
  nextStep,
  previousStep,
}) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!activationCode) {
      return gestioneSnackbar(true, t("validation.mandatory_code"), "error");
    }

    if (activationCode.length !== 6) {
      return gestioneSnackbar(true, t("validation.error_code"), "error");
    }

    nextStep();
  };

  return (
    <Stack gap={5} className="py-5">
      <Stack
        gap={3}
        className="d-flex justify-content-center align-items-center w-100"
      >
        <HeaderRegistration
          title={t("registration.title_activation_code")}
          subtitle={t("registration.subtitle_activation_code")}
        />
        <Form onSubmit={(e) => handleSubmit(e)}>
          <Form.Group
            className="mb-3 input-registration-wrapper"
            controlId="formPlaintextActivationCoded"
          >
            <Form.Control
              className="input-registration"
              maxLength={6}
              type="text"
              placeholder={t("registration.insert_activation_code")}
              value={activationCode}
              onChange={(e) => setActivationCode(e.target.value)}
              required
            />
          </Form.Group>
          <Button
            variant="light"
            size="md"
            className="button-registration"
            type="submit"
          >
            {t("common.next")}
          </Button>
        </Form>
      </Stack>
      <GoBack previousStep={previousStep} />
    </Stack>
  );
};

export default StepAssociation1;
